import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
	getCalendarInvite, removeCalendarMessage, downloadDocument, setLoadingState
} from '../actions';
import '../global';

class DownloadDocument extends Component {

	downloadDoc( file_name, download_file_name, document_id, bucket_name ) {
		this.props.downloadDocument( file_name, download_file_name, document_id, bucket_name );
	}

	getLoadingDocument() {
		return (<img src={getAjaxSpinner()}/>);
	}

	render() {

		let category = this.props.category;
		let loading_doc = '';
		let file_name = this.props.file_name;
		if ( this.props.generatingDocument === file_name ) {
			loading_doc = this.getLoadingDocument();
		}
		return (
			<button className="text-button attachment-link" data-meet-id={ this.props.meet_id } data-category={ category } data-document-id={ this.props.id } onClick={ this.downloadDoc.bind( this, this.props.file_name, this.props.download_file_name, this.props.id, this.props.bucket_name ) } type="button"> { loading_doc }
				<span className="glyphicon glyphicon-download" aria-hidden="true" />{ this.props.download_file_name }
			</button>
		);

	}

}

function mapStateToProps( { generatingDocument, loadingState } ) {
	return {
		generatingDocument, loadingState
	};
}

export default connect( mapStateToProps, {
	getCalendarInvite,
	removeCalendarMessage,
	downloadDocument,
	setLoadingState
} )( DownloadDocument );